import React, { memo } from 'react'

import Box from '@mui/material/Box'
import { RouteEnum } from '@appTypes/enums/global'
import { StyledWrapper } from './styled'

interface IContent {
  type: RouteEnum
  children: React.ReactNode
}

const Content = ({ type, children }: IContent) => {
  return (
    <StyledWrapper type={type}>
      <Box>{children}</Box>
    </StyledWrapper>
  )
}

export default memo(Content)
